import { $qs, $qsa } from '../../../src/js/utils/QuerySelector';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);


function horizontalIGScroller() {
    const container = $qs('[data-target="scroll-container-ig"]');
	const sectionIntro = $qs('[data-target="scroll-section-ig"]');
    const sections = $qsa('[data-target="scroll-section-ig"] > div');
    
    const getMaxWidth = () => [...sections].reduce((val, section) => val + section.offsetWidth, 0);
    let maxWidth = getMaxWidth();
	maxWidth += sectionIntro.offsetWidth + window.innerWidth / 2

    //console.log(maxWidth);
	let overlapped = false

    const timeline = gsap.timeline(
		{
			onUpdate: () => {
				if ( ! overlapped && sectionIntro.getBoundingClientRect().left + sectionIntro.clientWidth >  sections[0].getBoundingClientRect().left ) {
					overlapped = true

					gsap.to( sectionIntro, { autoAlpha: 0 } )
				}

				if ( overlapped && sectionIntro.getBoundingClientRect().left + sectionIntro.clientWidth <  sections[0].getBoundingClientRect().left  ){
					overlapped = false

					gsap.to( sectionIntro, { autoAlpha: 1 } )
				}
			},
		}
	);

    timeline.to(sections, { x: () => window.innerWidth - maxWidth, ease: 'none', });

    ScrollTrigger.create({
        animation: timeline,
        trigger: container,
        pin: true,
        pinSpacing: true,
        scrub: 1,        
        //   snap: {snapTo: directionalSnap(timeline), duration: 0.5},
        invalidateOnRefresh: true,
        end: () => `+=${maxWidth}`,
        // markers: true
    });

    ScrollTrigger.sort();
}

function instagramSlider() {
    // if (!$qs('.page-template-home')) return;
    if (!$qs('.block--instagram-slider')) return;
    
    window.addEventListener('load', () => {
        horizontalIGScroller();
    });
}

export default instagramSlider;